import { c as _c } from "react/compiler-runtime";
import { IcoSettings16 } from '@onefootprint/icons';
import { Popover, TextInput, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import MentionButton from '../chat-input/mention-button';
import ComposerEnvSelector from '../composer-env-selector';

// Popover, not a select: the override is a free-text Modal env. The trigger
// shows the value once set so a silent override is harder to forget.
const PercyEnvButton = t0 => {
  const $ = _c(50);
  const {
    value,
    onChange,
    disabled
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "form"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ask-percy", t1);
  let t2;
  if ($[1] !== value) {
    t2 = value.trim();
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isSet = !!t2;
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <label htmlFor="percy-env" className="text-caption-2 font-medium text-primary">{t4}</label>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t(_temp3);
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== onChange) {
    t7 = event => onChange(event.target.value);
    $[11] = onChange;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== value) {
    t8 = <TextInput id="percy-env" size="compact" placeholder={t6} value={value} onChange={t7} />;
    $[13] = t6;
    $[14] = t7;
    $[15] = value;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp4);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <p className="text-caption-3 text-tertiary">{t9}</p>;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t5 || $[23] !== t8) {
    t11 = <div className="flex w-[260px] flex-col gap-2 p-3">{t5}{t8}{t10}</div>;
    $[21] = t10;
    $[22] = t5;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t(_temp5);
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = !disabled;
  const t14 = !isSet;
  const t15 = !isSet && !disabled;
  let t16;
  if ($[27] !== disabled || $[28] !== isSet || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
    t16 = cx("flex h-8 md:h-7 items-center gap-1 rounded-full text-caption-2", {
      "cursor-default": disabled,
      "cursor-pointer": t13,
      "bg-neutral pl-1.5 pr-2 text-accent": isSet,
      "w-8 md:w-7 justify-center text-primary": t14,
      "hover:bg-hover": t15
    });
    $[27] = disabled;
    $[28] = isSet;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = disabled ? "quaternary" : isSet ? "accent" : "primary";
  let t18;
  if ($[33] !== t17) {
    t18 = <IcoSettings16 color={t17} />;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== isSet || $[36] !== value) {
    t19 = isSet && <span className="max-w-[120px] truncate">{value.trim()}</span>;
    $[35] = isSet;
    $[36] = value;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== disabled || $[39] !== t12 || $[40] !== t16 || $[41] !== t18 || $[42] !== t19) {
    t20 = <button type="button" aria-label={t12} disabled={disabled} className={t16}>{t18}{t19}</button>;
    $[38] = disabled;
    $[39] = t12;
    $[40] = t16;
    $[41] = t18;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t11 || $[45] !== t20) {
    t21 = <Popover side="top" align="start" sideOffset={8} content={t11}>{t20}</Popover>;
    $[44] = t11;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t21 || $[48] !== t3) {
    t22 = <Tooltip content={t3}>{t21}</Tooltip>;
    $[47] = t21;
    $[48] = t3;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  return t22;
};
type ComposerActionsOptions = {
  env?: {
    value?: 'sandbox' | 'production';
    onChange?: (value: 'sandbox' | 'production') => void;
    lockedTooltip?: string;
  };
  percyEnv?: {
    value: string;
    onChange: (value: string) => void;
  };
};
type ActionRenderers = {
  renderLeadingActions: (props: {
    disabled?: boolean;
  }) => ReactNode;
  renderExtraActions: (props: {
    triggerMention: () => void;
    disabled?: boolean;
  }) => ReactNode;
};
export const composerActions = ({
  env,
  percyEnv
}: ComposerActionsOptions): ActionRenderers => ({
  renderLeadingActions: ({
    disabled
  }) => <ComposerEnvSelector value={env?.value} onChange={env?.onChange} lockedTooltip={env?.lockedTooltip} disabled={disabled} />,
  renderExtraActions: ({
    triggerMention,
    disabled
  }) => <>
      <MentionButton onClick={triggerMention} disabled={disabled} />
      {percyEnv && <PercyEnvButton value={percyEnv.value} onChange={percyEnv.onChange} disabled={disabled} />}
    </>
});
function _temp($) {
  return $.envSettings;
}
function _temp2($_0) {
  return $_0.envLabel;
}
function _temp3($_1) {
  return $_1.envPlaceholder;
}
function _temp4($_2) {
  return $_2.envHelp;
}
function _temp5($_3) {
  return $_3.envSettings;
}